/* SQINWEAR · Descripción de producto con iconos.
   Las descripciones siguen todas la misma estructura (título, frase, lista «Compresión / Material / Tecnología / Extra»
   y «Por qué te va a gustar»). Este script reconoce esa estructura y la pinta como fichas con icono, sin tocar el texto
   de cada producto: si una descripción no sigue el formato, se queda como está. Vale también para la web en inglés. */
(function(){
  if (window.__sqDesc) return; window.__sqDesc = true;
  if (!document.body || !/template--product/.test(document.body.className)) return;

  var I = {
    comp: '<path d="M3 12h6M15 12h6M6 9l3 3-3 3M18 9l-3 3 3 3"/><path d="M12 5v14"/>',
    mat:  '<path d="M3 8c3-3 6 3 9 0s6 3 9 0M3 13c3-3 6 3 9 0s6 3 9 0M3 18c3-3 6 3 9 0s6 3 9 0"/>',
    tec:  '<path d="M12 3v4M12 17v4M3 12h4M17 12h4M6 6l2.5 2.5M15.5 15.5 18 18M6 18l2.5-2.5M15.5 8.5 18 6"/>',
    ext:  '<circle cx="12" cy="12" r="8.5"/><path d="M12 8v8M8 12h8"/>',
    love: '<path d="M12 20s-7-4.4-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.6-7 10-7 10z"/>',
    sup:  '<path d="M4 7c2.5 0 3.5 2 3.5 4.5S9.5 16 12 16s4.5-2 4.5-4.5S17.5 7 20 7"/><path d="M7.5 11.5 4 18M16.5 11.5 20 18"/>',
    fit:  '<path d="M7 4h10l2 4-3 1.5V20H8V9.5L5 8z"/>',
    abs:  '<path d="M12 3.5c3 4 6 7.2 6 10.5a6 6 0 0 1-12 0c0-3.3 3-6.5 6-10.5z"/>',
    def:  '<circle cx="12" cy="12" r="8.5"/><path d="m8.5 12.2 2.4 2.4 4.6-5"/>'
  };
  var K = [
    [/^(compresi[oó]n|compression)/i, 'comp'],
    [/^(material|tejido|fabric)/i, 'mat'],
    [/^(tecnolog[ií]a|technology)/i, 'tec'],
    [/^extra/i, 'ext'],
    [/^(sujeci[oó]n|support)/i, 'sup'],
    [/^(ajuste|fit)\b/i, 'fit'],
    [/^(absorci[oó]n|absorbency)/i, 'abs']
  ];
  function key(t){ for (var i = 0; i < K.length; i++){ if (K[i][0].test(t)) return K[i][1]; } return null; }
  function svg(k){ return '<svg viewBox="0 0 24 24" aria-hidden="true">' + I[k] + '</svg>'; }

  var css = ''
  + '.sq-desc-intro{font-size:15px!important;line-height:1.5!important;color:#111!important;margin:0 0 18px!important}'
  + '.sq-desc-title{display:none!important}'
  + '.sq-desc-list{list-style:none!important;margin:0 0 18px!important;padding:0!important;display:grid;gap:8px}'
  + '.sq-desc-list li{display:grid!important;grid-template-columns:36px 1fr;column-gap:12px;align-items:start;margin:0!important;padding:12px 14px!important;background:#f7f5f3;list-style:none!important;font-size:13px;line-height:1.45;color:#333}'
  + '.sq-desc-list li::before,.sq-desc-list li::marker{content:none!important;display:none!important}'
  + '.sq-desc-ic{grid-row:span 2;width:36px;height:36px;border-radius:50%;background:#f3ece4;display:flex;align-items:center;justify-content:center}'
  + '.sq-desc-ic svg{width:18px;height:18px;fill:none;stroke:#111;stroke-width:1.4;stroke-linecap:round;stroke-linejoin:round}'
  + '.sq-desc-k{display:block;font-size:11px!important;font-weight:500!important;letter-spacing:.08em;text-transform:uppercase;color:#6f6a69;margin:0 0 2px}'
  + '.sq-desc-love{display:grid!important;grid-template-columns:36px 1fr;column-gap:12px;align-items:center;margin:0!important;padding:14px!important;background:#f3ece4;font-size:13px!important;line-height:1.45!important;color:#111!important}'
  + '.sq-desc-love em{display:block;font-style:normal;font-size:11px;font-weight:500;letter-spacing:.08em;text-transform:uppercase;color:#6f6a69;margin-bottom:2px}'
  + '.sq-desc-love .sq-desc-ic{grid-row:auto;background:#fff}'
  + '.sq-desc-v{display:block}.sq-desc-v::first-letter{text-transform:uppercase}'
  + '.sq-desc-clip{position:relative;max-height:270px;overflow:hidden}'
  + '.sq-desc-clip::after{content:"";position:absolute;left:0;right:0;bottom:0;height:110px;background:linear-gradient(rgba(255,255,255,0),#fff 85%);pointer-events:none}'
  + '.sq-desc-more{margin:4px 0 0!important;text-align:center}'
  + '.sq-desc-more .sqin-ptabs__more{display:inline-flex;align-items:center;justify-content:center;min-height:42px;padding:0 22px;border:1px solid #111!important;background:#fff;color:#111;font-family:"Helvetica Neue",Helvetica,Arial,sans-serif;font-size:12px;font-weight:500;letter-spacing:.06em;text-transform:uppercase;text-decoration:none!important;cursor:pointer}';

  function style(){
    if (document.getElementById('sq-desc-css')) return;
    var s = document.createElement('style'); s.id = 'sq-desc-css'; s.textContent = css; document.head.appendChild(s);
  }

  function doList(ul){
    if (ul.dataset.sqDesc) return;
    var lis = Array.prototype.filter.call(ul.children, function(n){ return n.tagName === 'LI'; });
    if (lis.length < 2) return;
    var hits = lis.filter(function(li){ var s = li.querySelector('strong,b'); return s && key(s.textContent.trim()); });
    if (hits.length < 2) return;
    ul.dataset.sqDesc = '1';
    style();
    ul.classList.add('sq-desc-list');
    lis.forEach(function(li){
      var s = li.querySelector('strong,b');
      var k = s ? key(s.textContent.trim()) : null;
      var label = s ? s.textContent.replace(/:\s*$/, '').trim() : '';
      if (s) s.parentNode.removeChild(s);
      var body = li.innerHTML.replace(/^\s*:?\s*/, '');
      li.innerHTML = '<span class="sq-desc-ic">' + svg(k || 'def') + '</span><span><span class="sq-desc-k">' + label + '</span><span class="sq-desc-v">' + body + '</span></span>';
    });
    /* Frase de arriba y título repetido */
    var prev = ul.previousElementSibling;
    if (prev && prev.tagName === 'P' && !prev.querySelector('strong:only-child')) prev.classList.add('sq-desc-intro');
    var first = prev && prev.previousElementSibling;
    if (first && first.tagName === 'P' && first.children.length === 1 && /^(STRONG|B)$/.test(first.children[0].tagName) && first.textContent.trim() === first.children[0].textContent.trim()) first.classList.add('sq-desc-title');
    /* «Por qué te va a gustar» */
    var next = ul.nextElementSibling;
    if (next && next.tagName === 'P'){
      var em = next.querySelector('em,i');
      if (em && /gustar|love/i.test(em.textContent)){
        em.textContent = em.textContent.replace(/:\s*$/, '');
        var rest = next.innerHTML.replace(em.outerHTML, '').replace(/^\s*:?\s*/, '');
        next.innerHTML = '<span class="sq-desc-ic">' + svg('love') + '</span><span>' + em.outerHTML + '<span class="sq-desc-v">' + rest + '</span></span>';
        next.classList.add('sq-desc-love');
      }
    }
  }

  /* Pestaña Descripción cerrada: en vez del resumen cortado, se ve el principio de la descripción ya con sus fichas,
     difuminado hacia abajo, y el botón «Leer más» para verla entera */
  function descHtml(){
    var html = '';
    document.querySelectorAll('.section-complete-the-set menu-drawer').forEach(function(md){
      var t = md.querySelector('.drawer__button-text'), body = md.querySelector('.drawer__content .rte');
      if (html || !t || !body || !/descrip/i.test(t.textContent)) return;
      if (body.querySelector('.sq-desc-list')) html = body.innerHTML;
    });
    return html;
  }
  function collapsed(root){
    (root || document).querySelectorAll('.sqin-ptabs__panel .sqin-ptabs__more').forEach(function(b){
      if (!/^(Leer más|Read more)$/.test(b.textContent.trim())) return;
      var p = b.parentNode;
      if (p.dataset.sqDone) return;
      var html = descHtml(); if (!html) return;
      p.dataset.sqDone = '1';
      var clip = document.createElement('div');
      clip.className = 'sq-desc-clip';
      clip.innerHTML = html;
      p.parentNode.insertBefore(clip, p);
      Array.prototype.slice.call(p.childNodes).forEach(function(n){ if (n !== b) p.removeChild(n); });
      p.classList.add('sq-desc-more');
    });
  }

  function scan(root){ (root || document).querySelectorAll('ul').forEach(doList); collapsed(root); }
  function start(){
    scan();
    new MutationObserver(function(list){
      for (var i = 0; i < list.length; i++){
        for (var j = 0; j < list[i].addedNodes.length; j++){
          var n = list[i].addedNodes[j];
          if (n.nodeType === 1){ if (n.tagName === 'UL') doList(n); else if (n.querySelectorAll) scan(n); }
        }
      }
    }).observe(document.body, {childList: true, subtree: true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
